import * as React from "react";
import Seo from "../components/seo";
import { Link } from "gatsby";
import { Container, Row, Col, Image } from "react-bootstrap";
import { AwsserverlessservicesPageMeta } from "../data/metaData";
import { StaticImage } from "gatsby-plugin-image";
import LazyLoad from "react-lazy-load";
import Layout from "../components/layout/layout";

import WhyChooseUsIcon3 from "../images/icon/cloud-consulting-services-scalability-agility.svg";
import WhyChooseUsIcon7 from "../images/icon/aws-serverless-services-support.svg";

import BenefitsIcon3 from "../images/icon/aws-serverless-services-faster-development.svg";
import BenefitsIcon4 from "../images/icon/aws-serverless-services-solutions.svg";
import BenefitsIcon6 from "../images/icon/aws-cloud-migration-services-expense.svg";
import BenefitsIcon7 from "../images/icon/aws-serverless-services-management.svg";

const AWSCertificate = React.lazy(() => import("../components/aws-certificate"))
const ClientsTestimonial = React.lazy(() => import('../components/clients-testimonial'))
const AwardsAWS = React.lazy(() => import("../components/awards-aws"))
// const CaseStudy = React.lazy(() => import('../components/case-study'))
const BlogList = React.lazy(() => import('../components/blog/blog-list'))
// const Faqs = React.lazy(() => import('../components/faqs'))
const Usecaseaws = React.lazy(() => import('../components/usecase-aws'))

export const Head = () => (
  <Seo
    title={AwsserverlessservicesPageMeta.metaTitle}
    description={AwsserverlessservicesPageMeta.metaDescription}
    ogImage={AwsserverlessservicesPageMeta.ogImage}
    twitterImage={AwsserverlessservicesPageMeta.twitterImage}
  />
)

const AwsserverlessservicesPage = () => {

  const CTABgDark = '../images/cta-bg-dark1.png'
  const BgDark = '../images/bg-gradient-image.png'
  const BgGreenPattrenBottomLeft = '../images/bg-gradient-image-green-bottom-left.png'
  const BgGreenPattrenTopRight = '../images/bg-gradient-image-green-top-right.png'


  const excellencedevelopers = [
    {
      icon: BenefitsIcon7,
      title: "No infrastructure management",
      des: "Eliminate the need to provision or manage servers with our AWS serverless computing.",
      width: 60,
      height: 60
    },
    {
      icon: WhyChooseUsIcon3,
      title: "Automatic scaling",
      des: "Seamlessly scale apps to handle variable workloads with our AWS serverless application development expertise. ",
      width: 60,
      height: 60
    },
    {
      icon: BenefitsIcon3,
      title: "Faster development",
      des: "Focus on writing code, while migrating to AWS serverless infrastructure without worrying about architecture.",
      width: 60,
      height: 60
    },
  ]
  const keafeture = [
    {
      icon: BenefitsIcon4,
      title: "Custom solutions",
      des: "Custom serverless architecture designs are built by our cloud experts for optimal performance and efficiency.",
    },
    {
      icon: BenefitsIcon7,
      title: "Expert tool integration",
      des: "Our AWS-certified experts are pros at using AWS Lambda, DynamoDB, and API Gateway for scalable serverless solutions on AWS.",
    },
    {
      icon: WhyChooseUsIcon7,
      title: "Comprehensive support",
      des: "Our full-service support caters to you from design to deployment and monitoring in your serverless journey.",
    },
    {
      icon: BenefitsIcon6,
      title: "Cost optimisation",
      des: "Our cost-effective serverless computing with AWS minimizes infrastructure costs by implementing pay-as-you-go models.",
    }
  ]
  const stickydata = [
    {
      title: "Event Source",
      des: "Applications trigger events through AWS API Gateway, S3, or DynamoDB Streams.",
      list: [
        {
          tech: "API Gateway"
        },
        {
          tech: "S3"
        },
        {
          tech: "DynamoDB Streams"
        },
      ]
    },
    {
      title: "Compute Layer",
      des: "AWS Lambda processes events and runs code without provisioning servers.",
      list: [
        {
          tech: "AWS Lambda"
        }
      ]
    },
    {
      title: "Data Layer",
      des: "Data is stored and retrieved through managed serverless solutions on AWS effortlessly.",
      list: [
        {
          tech: "DynamoDB"
        },
        {
          tech: "S3"
        },
        {
          tech: "Aurora Serverless"
        }
      ]
    },
    {
      title: "Monitoring Layer",
      des: " AWS serverless computing for real-time data processing ensures applications perform optimally",
      list: [
        {
          tech: "AWS CloudWatch"
        },
        {
          tech: "X-Ray"
        },
        {
          tech: "AWS Config"
        }
      ]
    }
  ]
  const choosedata = [
    {
      title: "Faster time-to-market",
      description: "Rapidly develop and deploy applications without managing infrastructure."
    },
    {
      title: "Reduced infrastructure costs",
      description: "Serverless pricing ensures you only pay for what you use avoiding any extra cost"
    },
    {
      title: "Improved agility",
      description: "Adapt quickly to evolving business and customer needs with our agile approaches."
    },
    {
      title: "Focus on innovation",
      description: "Spend more time on building features and less on managing infrastructure."
    },
  ]

  return (
    <>
      <Layout headerClass="navbar-dark">
        <section className="section bg-black section-background d-flex min-vh-100 align-items-center">
          <Container className="py-5 my-auto">
            <div className="text-center max-width-950 mx-auto">
              <h1 className="sub-title mb-3 text-white-75">AWS SERVERLESS SERVICES</h1>
              <h2 className="h1 mb-4 text-white">
                <span className="text-primary">Serverless architecture services:</span> Build, run, and scale apps effortlessly
              </h2>
              <p className="lead text-white-75 mb-5">
                Utilize our experts-led AWS serverless services to build modern applications without managing infrastructure. From Lambda to DynamoDB, our cloud experts are equipped with all the advanced skill sets to help you deploy scalable, cost-efficient serverless development solutions with ease.
              </p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline">
                Let’s start now
              </Link>
            </div>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={BgDark}
              alt='Background pattren'
            />
          </LazyLoad>
        </section>
        <AWSCertificate sectionClass="bg-light" />
        <section className="section">
          <Container className="py-5">
            <div className="mb-5 pb-1 max-width-950">
              <h2 className="mb-4">Importance of <span className="text-primary">AWS serverless architecture</span> for modern businesses</h2>
              <p className="lead mb-0">AWS serverless architecture eliminates the need to manage servers, allowing businesses to focus on building scalable and agile applications with ease. It reduces operational overhead, optimizes resource usage, and ensures seamless scaling for modern workloads. Here are a few major reasons why amazon serverless services is necessary for your business growth:</p>
            </div>

            <Row className="g-4" xs={1} md={2} lg={3}>
              {
                excellencedevelopers?.map((item, index) => {
                  return (
                    <Col key={index}>
                      <div className="dark-box-1 left-icon-box equal-height">
                        <div className="icon-size-85 d-flex align-items-center mb-2">
                          <Image
                            loading="lazy"
                            className="lazyload"
                            src={item.icon}
                            alt={`TechnologiesIcon`}
                            width={item.width}
                            height={item.height}
                          />
                        </div>
                        <h3 className="font-size-22 mb-3">{item.title}</h3>
                        <p className="mb-0">{item.des}</p>
                      </div>
                    </Col>
                  )
                })
              }
            </Row>
          </Container>
        </section>

        <section className="section bg-black">
          <Container className="py-5">
            <Row className="g-5">
              <Col lg={6}>
                <div className="sticky-section mb-3">
                  <h2 className="mb-4 text-white">
                    How <span className="text-primary">AWS serverless</span> architecture works?
                  </h2>
                  <p className="lead text-white-75 mb-0">Discover how AWS serverless services streamline application development. From triggering Lambda functions to managing databases with DynamoDB, our architecture ensures seamless performance. Here’s what happens:</p>
                  {/* <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                          Talk to Us
                        </Link> */}
                </div>
              </Col>
              <Col lg={6}>
                <div className="border-box1">
                  <Row className="g-0" xs={1} md={1} lg={1}>
                    {
                      stickydata.map((item, index) => (
                        <Col key={index}>
                          <div className="dark-box-2 border bg-transparent rounded-0">
                            {/* <i className="icon-check-square-sprite icon-size-40 mb-3"></i> */}
                            <h3 className="text-white font-size-22 mb-3">{item.title} </h3>
                            <p className="text-white-75 mb-4">{item.des}</p>
                            <Row as="ul" xs="auto" className="list-unstyled g-2 mb-0 border-0">
                              {item.list.map((item, index) => (
                                <Col as="li" className="border-0 p-0 pe-2 pb-2" key={index}>
                                  <span className="badge-tecnology architecture-border">{item.tech}</span>
                                </Col>
                              ))
                              }
                            </Row>
                          </div>
                        </Col>
                      ))
                    }
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Core highlights of our <span className="text-primary">AWS serverless computing</span>
              </h2>
              <p className="lead mb-0">Our AWS serverless consulting services help you achieve faster application development with zero infrastructure management. Explore the features that make our solutions the ideal choice for modern businesses.</p>
            </div>
            <Row className="g-4" xs={1} md={1} lg={2} xl={2}>
              {
                keafeture.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-2 equal-height">
                      <div className="d-flex align-items-start">
                        <Image loading="lazy" className="lazyload" src={item.icon} width={50} height={50} alt="benefits-icon" />
                        <div className="ms-3">
                          <h3 className="font-size-22 mb-3">{item.title}</h3>
                          <p className="mb-0">{item.des}</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>
        <Usecaseaws />

        <section className={`section bg-black section-background`} >
          <Container className="py-5">
            <div className="mb-5 pb-1 max-width-950">
              <h2 className="mb-4 text-white">Benefits of choosing our <span className="text-primary">serverless development solutions</span></h2>
              <p className="lead mb-0 text-white-75">AWS serverless architecture enables businesses to innovate faster, reduce costs, and scale without limits. Here’s how our serverless solutions benefit your business.</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={2}>
              {
                choosedata?.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-1 top-green-box-header equal-height">
                      <i className="icon-check-square-sprite d-flex align-items-center icon-size-40 mb-4"></i>
                      {/* <p class="text-primary mb-3"><i class="zmdi zmdi-dot-circle zmdi-hc-fw font-size-24"></i></p> */}
                      <h3 className="h4 text-white mb-3">{item.title}</h3>
                      <p className="text-white-75 mb-0">{item.description}</p>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
          <LazyLoad>
            <div style={{ opacity: "0.1" }}>
              <StaticImage
                style={{ position: 'absolute' }}
                className='section-background-image bottom-right'
                loading='lazy'
                src={BgGreenPattrenTopRight}
                alt='Background pattren'
              />
            </div>
          </LazyLoad>
          <LazyLoad>
            <div style={{ opacity: "0.1" }}>
              <StaticImage
                style={{ position: 'absolute' }}
                className='section-background-image top-left'
                loading='lazy'
                src={BgGreenPattrenBottomLeft}
                alt='Background pattren'
              />
            </div>
          </LazyLoad>
        </section>

        <ClientsTestimonial title="Client feedback on our <span class='text-primary'>AWS serverless architecture services</span>" description="Hear from our clients who have experienced faster development, cost savings, and seamless scalability with our AWS serverless services." />
        <AwardsAWS sectionClass="bg-white" />
        <section className="section bg-black section-background">
          <Container className="py-5">
            <div className="text-center max-width-950 mx-auto">
              <h2 className="heading text-white mb-4">
                Want to avoid all your <span className="text-primary">server complexities?</span>
              </h2>
              <p className="lead text-white-75 mb-4">Let’s scale without limits with our serverless architecture services.</p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Start now
              </Link>
            </div>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={CTABgDark}
              alt='Home banner pattren'
            />
          </LazyLoad>
        </section>
        {/* <Faqs accordian={accordian} sectionClass="bg-light" /> */}
        <BlogList
          title="Featured <span class='text-primary'>blogs</span>"
          description="Stay updated with the latest AWS serverless trends, insights, and best practices from our cloud experts."
          sectionClass="bg-white"
        />
      </Layout>
    </>
  );
};

export default AwsserverlessservicesPage;
